import { RaisinContainer as Container } from '@raisin/components-lib';
import { hasCookieForMobile, isCustomerLoggedIn, isMobileApp } from '@raisin/cp-utils';
import React, { useEffect, useState } from 'react';
import ContentLinks from './ContentLinks';
import FooterDisclaimer from './FooterDisclaimer';
import FooterImprint from './FooterImprint';
import IconsBar from './IconsBar';
import MobileBanner from './MobileBanner';
import * as S from './styles';
import TrustPilotBar from './TrustPilotBar';
import UsContactBanner from './UsContactBanner';
const Footer = ({ footerData: { trustpilotData, socialMediaIcons, contactInformationData, mobileBannerIconURL, mobile_banner: { display_mobile_banner }, display_trustpilot, displayUsContactBanner, hideFooterLinks, footer_links, legal_links, copyright, credits, disclaimer, hideCountryPicker, hideSocialMediaHeading, usContactBanner, }, locale, }) => {
    const [shouldDisplayMobileBanner, setShouldDisplayMobileBanner] = useState(display_mobile_banner);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const isMobileAppWebView = isMobileApp();
    useEffect(() => {
        setShouldDisplayMobileBanner(display_mobile_banner && !hasCookieForMobile());
    }, [display_mobile_banner]);
    useEffect(() => {
        if (!isLoggedIn && isCustomerLoggedIn()) {
            setIsLoggedIn(isCustomerLoggedIn());
        }
    }, [isLoggedIn]);
    const shouldDisplayContentLinks = !hideFooterLinks && !isLoggedIn && !!(footer_links === null || footer_links === void 0 ? void 0 : footer_links.length);
    const shouldDisplayTopBorder = !display_trustpilot &&
        !contactInformationData &&
        !socialMediaIcons &&
        !shouldDisplayContentLinks;
    if (isMobileAppWebView) {
        return null;
    }
    return (React.createElement(S.Container, { borderTop: shouldDisplayTopBorder, className: "footer" },
        display_trustpilot && React.createElement(TrustPilotBar, { trustpilotData: trustpilotData }),
        displayUsContactBanner && usContactBanner && (React.createElement(UsContactBanner, { contactData: usContactBanner })),
        shouldDisplayContentLinks && React.createElement(ContentLinks, { footerLinks: footer_links, locale: locale }),
        shouldDisplayMobileBanner && React.createElement(MobileBanner, { mobileBannerIconURL: mobileBannerIconURL }),
        React.createElement(Container, { maxWidth: "xl" },
            React.createElement(IconsBar, { hideSocialMediaHeading: hideSocialMediaHeading, credits: credits, socialMediaIcons: socialMediaIcons, SocialMediaHeading: contactInformationData === null || contactInformationData === void 0 ? void 0 : contactInformationData.social_media_heading }),
            React.createElement(FooterImprint, { hideCountryPicker: hideCountryPicker || isLoggedIn, legalLinks: legal_links, copyright: copyright, shouldHideTopBorder: shouldDisplayTopBorder || shouldDisplayMobileBanner || hideFooterLinks }),
            disclaimer && React.createElement(FooterDisclaimer, { disclaimer: disclaimer }))));
};
export default Footer;
//# sourceMappingURL=index.js.map